import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueScrollTo from "vue-scrollto";
import VueScrollReveal from "vue-scroll-reveal";
import Vuelidate from "vuelidate";
import * as SmartyStreetsSDK from "smartystreets-javascript-sdk";
import VueTheMask from "vue-the-mask";
import VueFormGenerator from "vue-form-generator";
import 'vue-form-generator/dist/vfg.css';
import VueTelInput from "vue-tel-input";
import TelInput from "./views/content/components/Tel-Input.vue";
import "cleave.js";
import "cleave.js/dist/addons/cleave-phone.us.js";
import "vue-tel-input/dist/vue-tel-input.css";

Vue.component("field-tel-input", TelInput);

Vue.use(VueTelInput);
Vue.use(VueFormGenerator);
Vue.use(VueTheMask);
Vue.use(VueScrollTo);
Vue.use(VueScrollReveal, {
  duration: 300,
  scale: 1,
  distance: "10px",
  mobile: false,
  reset: false,
  viewFactor: 0.1
});
Vue.use(Vuelidate);
Vue.use(SmartyStreetsSDK);

Vue.config.productionTip = false;

require("./assets/sass/main.scss");

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
